import { flowRight, omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { EXPERIMENT_MOBILE_MENU_COLOR_MATCH_DESKTOP } from '@wix/communities-blog-experiments';
import withTranslate from '../../../common/hoc/with-translate';
import BackButton from '../../containers/back-button';
import ArrowBackIcon from '../../../common/components/icons/arrow-back-icon';
import withFontClassName from '../../../common/hoc/with-font-class-name';
import withExperiment from '../../../common/hoc/with-experiment';
import styles from './header-back-button.scss';

const HeaderBackButton = ({
  component: ContainerComponent,
  arrow,
  text,
  t,
  contentFontClassName,
  isMobileMenuColorMatchDesktopExperimentEnabled,
  ...rest
}) => {
  const iconClassName = isMobileMenuColorMatchDesktopExperimentEnabled
    ? classNames(styles.icon, 'blog-navigation-container-fill')
    : classNames(styles.icon, 'blog-button-primary-icon-fill');
  const containerComponentProps =
    ContainerComponent === 'button' ? omit(rest, ['titleFontClassName', 'dispatch', 'tReady', 'lng']) : rest;

  const wrapperClassName = isMobileMenuColorMatchDesktopExperimentEnabled
    ? styles.wrapper
    : classNames(styles.wrapper, contentFontClassName);
  const labelClassName = isMobileMenuColorMatchDesktopExperimentEnabled
    ? classNames(styles.label, 'blog-navigation-container-color')
    : classNames(styles.label, 'blog-button-primary-text-color');

  return (
    <ContainerComponent className={classNames(styles.button, 'header-back-button')} {...containerComponentProps}>
      <span className={wrapperClassName}>
        {arrow ? <ArrowBackIcon className={iconClassName} /> : null}

        <span className={labelClassName}>{text && t(text)}</span>
      </span>
    </ContainerComponent>
  );
};

HeaderBackButton.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  arrow: PropTypes.bool,
  text: PropTypes.string,
  t: PropTypes.func,
  contentFontClassName: PropTypes.string,
  isMobileMenuColorMatchDesktopExperimentEnabled: PropTypes.bool,
};

HeaderBackButton.defaultProps = {
  component: BackButton,
  text: 'header-back-button.back',
};

export default flowRight(
  withFontClassName,
  withTranslate,
  withExperiment({
    isMobileMenuColorMatchDesktopExperimentEnabled: EXPERIMENT_MOBILE_MENU_COLOR_MATCH_DESKTOP,
  }),
)(HeaderBackButton);
